import BasicDrawer from '@components/common/molecules/drawer/BasicDrawer';
import RestaurantOfferStore from "@components/offer/stores/RestaurantOfferStore";
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import { Typography } from '@mui/material';
import OrderDetailsDrawerView from './OrderDetailsDrawerView';
import OrderDetailsDrawerHeader from './OrderDetailsDrawerHeader';
import BottomAction from './BottomAction';

interface OrderDetailsDrawerProps {
    orderListViewStore: OrderListViewStore;
}

const OrderDetailsDrawer: FC<OrderDetailsDrawerProps> = observer(({ orderListViewStore }) => {
    const { isOrderDetailsDrawerOpen, setIsOrderDetailsDrawerOpen } = orderListViewStore;

    const handleOnClose = () => {
        setIsOrderDetailsDrawerOpen(false);
    }

    // if (clonedSelectedFood === undefined) {
    //     return null;
    // }

    return (
        <BasicDrawer
            isOpen={isOrderDetailsDrawerOpen}
            onClose={handleOnClose}
            header={<OrderDetailsDrawerHeader />}>
            <>
                <OrderDetailsDrawerView orderListViewStore={orderListViewStore} />
            </>
        </BasicDrawer>
    )
})

export default OrderDetailsDrawer;